import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { GiFairyWings } from "react-icons/gi";
import { FaRegCalendarAlt, FaImage } from "react-icons/fa";
import "./News.css";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://localhost:5000";

const formatCardDate = (dateString) => {
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

const getYearFromDate = (dateString) => {
  return new Date(dateString).getFullYear().toString();
};

function News() {
  const [newsData, setNewsData] = useState([]);
  const [activeYear, setActiveYear] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/news/public`
        );

        const data = await response.json();
        setNewsData(data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  const years = [
    "All",
    ...new Set(
      newsData.map((item) =>
        getYearFromDate(item.publishDate)
      )
    ),
  ]
    .sort()
    .reverse();

  const filteredNews =
    activeYear === "All"
      ? newsData
      : newsData.filter(
          (item) =>
            getYearFromDate(item.publishDate) === activeYear
        );

  if (loading) {
    return (
      <div className="news-page-loading">
        Loading News...
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>News | Rajput Shiksha Kosh</title>
        <meta
          name="description"
          content="Latest news and announcements from Rajput Shiksha Kosh."
        />
      </Helmet>

      <div className="news-page-wrapper">
        <div className="news-page-container">

          {/* HEADER */}
          <div className="news-page-header">
            <h1 className="news-page-title">
              Latest News
            </h1>

            <div className="news-page-divider">
              <span className="news-page-line"></span>

              <GiFairyWings className="news-page-icon" />

              <span className="news-page-line"></span>
            </div>
          </div>

          {/* FILTER */}
          <div className="news-page-filter-wrapper">
            <div className="news-page-filter-bar">

              <div className="news-page-filter-left">
                News & Announcements
              </div>

              <div className="news-page-filter-right">
                <label>Filter By Year</label>

                <select
                  value={activeYear}
                  onChange={(e) =>
                    setActiveYear(e.target.value)
                  }
                >
                  {years.map((year) => (
                    <option
                      key={year}
                      value={year}
                    >
                      {year}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* GRID */}
          <div className="news-page-grid">

            {filteredNews.length > 0 ? (
              filteredNews.map((news) => (
                <Link
                  to={`/news/${news.slug}`}
                  key={news._id}
                  className="news-page-card"
                >

                  {/* IMAGE */}
                  <div className="news-page-image-wrapper">

                    {news.image ? (
                      <img
                        src={`${API_BASE_URL}${news.image}`}
                        alt={news.title}
                        className="news-page-image"
                      />
                    ) : (
                      <div className="news-page-no-image">
                        <FaImage />
                        <span>No Image</span>
                      </div>
                    )}

                  </div>

                  {/* CONTENT */}
                  <div className="news-page-content">

                    <h2 className="news-page-card-title">
                      {news.title}
                    </h2>

                    <div className="news-page-date">
                      <FaRegCalendarAlt />
                      {formatCardDate(news.publishDate)}
                    </div>

                  </div>

                </Link>
              ))
            ) : (
              <div className="news-page-empty">
                No news found
              </div>
            )}

          </div>
        </div>
      </div>
    </>
  );
}

export default News;